<template>
  <v-dialog
    v-model="show"
    :fullscreen="fullscreen"
    :max-width="maxWidth"
  >
    <v-card >
      <v-card-title class="text-h5 justify-center" :class="type" style="color: white;">
        {{title}}
        <v-spacer></v-spacer>
          <v-btn
            icon
            dark
            @click="show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
      </v-card-title>

      <v-card-text>
        <p class="justify-center pt-5" v-if="content">
          {{content}}
        </p>
        <v-img
          max-with="100%"
          :src="image"
          v-if="image"
        ></v-img>
        <div class="box-container  justify-center">
          <span class="box" style="background-color: #085da1"> </span>
          <span class="box" style="background-color: #a7ba38"> </span>
          <span class="box" style="background-color: #e79024"> </span>
          <span class="box" style="background-color: #db1d4a"> </span>
          <span class="box" style="background-color: #8fc6dc"> </span>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "ModalCustom",
  components: {},
  props:{
    show: {
      type: Boolean,
      default: false,
      required: true
    },
    content: {
      type: String,
      required: false
    },
    image: {
      type: String,
      required: false
    },
    title: {
      type: String,
      default:'Importante',
      required: false
    },
    type: {
      type: String,
      default:'modal-success',
      required: false
    },
    fullscreen: {
      type: Boolean,
      default:false,
      required: false
    },
    maxWidth: {
      type: Number,
      default:290,
      required: false
    },
  },
  data: () => ({
    
    
  }),
  watch: {
    show (val) {
      !val && this.$emit('update', val)
    }
  },
  methods: {}
};
</script>
  <style>
  .box{
    width: 8px;
    height:7px;
    margin:5px;
    display:inline-block;
  }
  .box-container{
    text-align: center;
  }
  .modal-success{
    background-color: #a6ba37;
  }
  .modal-info{
    background-color: #80c5dc;
  }
  .modal-warning{
    background-color: #ef932b;
  }
  .modal-primary{
    background-color: #134b9e;
  }
  .modal-danger{
    background-color: #eb423e;
  }
  </style>

